import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import {
  CDropdown,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
} from "@coreui/react";
import Form from "react-bootstrap/Form";

import { connect } from "react-redux";
import { notify } from "../../functions/function";
import {
  readableDateTime,
  convDateObjToISO,
  convIsoToDateObj,
} from "../../functions/timeFormat";
import axios from "axios";

import CustomDatePicker from "../../components/CustomDatePicker";
import { iStaffBaseURL } from "src/constants/Urls";

import SmallLoadingSpinner from "../../components/SmallLoadingSpinner";
import { dispatchManualSubmitTimesheet } from "./helperFunctions";

const AmendTimesheetModal = ({
  show,
  handleClose,
  row,
  rows,
  id,
  dispatch,
  userToken,
  pendingPlacements,
  event,
}) => {
  /* Event refers to the user movement (i.e. clicking and dragging) */
  /* using same names as model fields in Django */
  const [formData, setFormData] = useState({
    iStaff_id: "",
    first_name: "",
    last_name: "",
    trade: "",
    start_time: new Date(),
    end_time: new Date(),
    location: "",
    clock_in_time: "",
    clock_in_location: "Manual Submission",
    clock_out_time: "",
    clock_out_location: "Manual Submission",
    approval_status: "Pending",
    client_approval_status: "Pending",
  });

  const [state, setState] = useState({
    loading: false,
  });

  useEffect(() => {
    var currentRow = rows.filter((x) => x.id === id[0])[0];

    if (currentRow.timesheet) {
      setFormData((formData) => ({
        ...formData,
        iStaff_id: currentRow.iStaff_id,
        first_name: currentRow.employee.user.first_name,
        last_name: currentRow.employee.user.first_name,
        trade: currentRow.trade,
        start_time: convIsoToDateObj(currentRow.start_time),
        end_time: convIsoToDateObj(currentRow.end_time),
        location: currentRow.location,
        clock_in_time: currentRow.timesheet.clock_in_time
          ? convIsoToDateObj(currentRow.timesheet.clock_in_time)
          : convIsoToDateObj(currentRow.start_time),
        clock_in_location:
          currentRow.timesheet.human_readable_location_clock_in !== null
            ? currentRow.timesheet.human_readable_location_clock_in
            : "Missing Location",
        clock_out_time: currentRow.timesheet.clock_out_time
          ? convIsoToDateObj(currentRow.timesheet.clock_out_time)
          : convIsoToDateObj(currentRow.end_time),
        clock_out_location:
          currentRow.timesheet.human_readable_location_clock_out !== null
            ? currentRow.timesheet.human_readable_location_clock_out
            : "Missing Location",
      }));
    } else {
      setFormData((formData) => ({
        ...formData,
        iStaff_id: currentRow.iStaff_id,
        first_name: currentRow.employee.user.first_name,
        last_name: currentRow.employee.user.first_name,
        trade: currentRow.trade,
        start_time: convIsoToDateObj(currentRow.start_time),
        end_time: convIsoToDateObj(currentRow.end_time),
        location: currentRow.location,
        clock_in_time: convIsoToDateObj(currentRow.start_time),
        clock_out_time: convIsoToDateObj(currentRow.end_time),
      }));
    }
  }, [event]);

  var currentRow = rows.filter((x) => x.id === id[0])[0];

  const handleStartDateTimeChange = (e) => {
    setFormData({ ...formData, clock_in_time: e });
  };

  const handleEndDateTimeChange = (e) => {
    setFormData({ ...formData, clock_out_time: e });
  };

  const handleClockInLocation = (e) => {
    setFormData({ ...formData, clock_in_location: e.target.value });
  };

  const handleiStaffApprove = () => {
    setFormData({ ...formData, approval_status: "Approved" });
  };
  const handleiStaffDecline = () => {
    setFormData({ ...formData, approval_status: "Declined" });
  };

  const handleClockOutLocation = (e) => {
    setFormData({ ...formData, clock_out_location: e.target.value });
  };

  const handleSubmit = (currentRow, userToken) => {
    setState({ loading: true });
    if (currentRow.timesheet) {
      axios
        .put(
          iStaffBaseURL + `/handler/placements/${currentRow.id}/timesheet`,
          {
            clock_in_time: convDateObjToISO(formData.clock_in_time),
            clock_in_latitude: "0.000001",
            clock_in_longitude: "0.000001",
            clock_out_time: convDateObjToISO(formData.clock_out_time),
            human_readable_location_clock_in: formData.clock_in_location
              ? formData.clock_in_location
              : "Manual Submission",
            human_readable_location_clock_out: formData.clock_out_location
              ? formData.clock_out_location
              : "Manual Submission",
            approval_status: formData.approval_status,
            client_approval_status: formData.client_approval_status,
            is_complete:
              formData.approval_status && formData.client_approval_status
                ? true
                : false,
          },
          {
            headers: { Authorization: `Token ${userToken}` },
          }
        )
        .then((response) => {
          var timesheetObjectToAdd = {
            clock_in_time: convDateObjToISO(formData.clock_in_time),
            clock_in_latitude: "0.000001",
            clock_in_longitude: "0.000001",
            clock_out_time: convDateObjToISO(formData.clock_out_time),
            human_readable_location_clock_in: formData.clock_in_location
              ? formData.clock_in_location
              : "Manual Submission",
            human_readable_location_clock_out: formData.clock_out_location
              ? formData.clock_out_location
              : "Manual Submission",
            approval_status: formData.approval_status,
            client_approval_status: formData.client_approval_status,
            is_complete:
              formData.approval_status && formData.client_approval_status
                ? true
                : false,
          };

          dispatchManualSubmitTimesheet(
            dispatch,
            convDateObjToISO(formData.clock_in_time),
            convDateObjToISO(formData.clock_out_time),
            pendingPlacements,
            currentRow.id,
            timesheetObjectToAdd
          );
          setState({ loading: false });

          handleClose();
          notify("Success", "Timesheet successfully created", "success");

          if (
            formData.approval_status !== "Pending" &&
            formData.client_approval_status !== "Pending"
          ) {
            notify(
              "Success",
              "Timesheet successfully moved to history",
              "success"
            );
          }
        })
        .catch((error) => {
          setState({ loading: false });
          notify("Failed", "Error occured. Please try again", "danger");
        });
    } else {
      axios
        .post(
          iStaffBaseURL + `/handler/placements/${currentRow.id}/timesheet`,
          {
            clock_in_latitude: "0.000001",
            clock_in_longitude: "0.000001",
            clock_in_time: convDateObjToISO(formData.clock_in_time),
            clock_out_latitude: null,
            clock_out_longitude: null,
            clock_out_time: convDateObjToISO(formData.clock_out_time),
            description: "",
            human_readable_location_clock_in: formData.clock_in_location
              ? formData.clock_in_location
              : "Manual Submission",
            human_readable_location_clock_out: formData.clock_out_location
              ? formData.clock_out_location
              : "Manual Submission",
            id: 290,
            approval_status: formData.approval_status,
            client_approval_status: formData.client_approval_status,
            is_complete:
              formData.approval_status && formData.client_approval_status
                ? true
                : false,
            placement: currentRow.id,
          },
          {
            headers: { Authorization: `Token ${userToken}` },
          }
        )
        .then((response) => {
          var timesheetObjectToAdd = {
            clock_in_latitude: "0.000001",
            clock_in_longitude: "0.000001",
            clock_in_time: convDateObjToISO(formData.clock_in_time),
            clock_out_latitude: null,
            clock_out_longitude: null,
            clock_out_time: convDateObjToISO(formData.clock_out_time),
            description: "",
            human_readable_location_clock_in: formData.clock_in_location
              ? formData.clock_in_location
              : "Manual Submission",
            human_readable_location_clock_out: formData.clock_out_location
              ? formData.clock_out_location
              : "Manual Submission",
            id: 290,
            approval_status: formData.approval_status,
            client_approval_status: formData.client_approval_status,
            is_complete:
              formData.approval_status && formData.client_approval_status
                ? true
                : false,
            placement: currentRow.id,
          };
          dispatchManualSubmitTimesheet(
            dispatch,
            convDateObjToISO(formData.clock_in_time),
            convDateObjToISO(formData.clock_out_time),
            pendingPlacements,
            currentRow.id,
            timesheetObjectToAdd
          );
          handleClose();
          setState({ loading: false });
          notify("Success", "Timesheet successfully created", "success");

          if (
            formData.approval_status !== "Pending" &&
            formData.client_approval_status !== "Pending"
          ) {
            notify(
              "Success",
              "Timesheet successfully moved to history",
              "success"
            );
          }
        })
        .catch((error) => {
          console.log(error);
          setState({ loading: false });
          notify("Failed", "Error occured. Please try again", "danger");
        });
    }
  };

  return (
    <Modal show={show} onHide={handleClose} size={"l"}>
      <Modal.Header closeButton>
        <Modal.Title>TimeSheet Manual Submission</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form className="text-left">
          <Form.Group>
            <Form.Label column lg="50">
              iStaff ID : {currentRow.iStaff_id}
            </Form.Label>
          </Form.Group>

          <Form.Group>
            <Form.Label column lg="50">
              Name : {currentRow.employee.user.first_name}{" "}
              {currentRow.employee.user.last_name}
            </Form.Label>
          </Form.Group>

          <Form.Group>
            <Form.Label column lg="50">
              Order Id : {currentRow.order_id}
            </Form.Label>
          </Form.Group>

          <Form.Group>
            <Form.Label column lg="50">
              Trade : {currentRow.trade}
            </Form.Label>
          </Form.Group>

          <Form.Group>
            <Form.Label column sm="50">
              Start Time : {readableDateTime(currentRow.start_time)}
            </Form.Label>
          </Form.Group>

          <Form.Group>
            <Form.Label column sm="50">
              Clock In Time:
            </Form.Label>

            <Form.Text column sm="50">
              <CustomDatePicker
                value={formData.clock_in_time}
                onChange={handleStartDateTimeChange}
              />
            </Form.Text>
          </Form.Group>

          <Form.Group>
            <Form.Label column sm="50">
              Clock In Location :
            </Form.Label>
            {formData.clock_in_location ? (
              <Form.Control
                placeholder={formData.clock_in_location}
                onChange={handleClockInLocation}
              />
            ) : (
              <Form.Control
                placeholder="Enter Address"
                onChange={handleClockInLocation}
              />
            )}
          </Form.Group>

          <Form.Group>
            <Form.Label column sm="50">
              End Time : {readableDateTime(currentRow.end_time)}
            </Form.Label>
          </Form.Group>

          <Form.Group controlId="formPlaintextEmail" column sm="50">
            <Form.Label column sm="50">
              Clock Out Time:
            </Form.Label>
            <Form.Text column sm="50">
              <CustomDatePicker
                value={formData.clock_out_time}
                onChange={handleEndDateTimeChange}
              />
            </Form.Text>
          </Form.Group>

          <Form.Group>
            <Form.Label column sm="50">
              Clock Out Location :
            </Form.Label>
            {formData.clock_out_location ? (
              <Form.Control
                placeholder={formData.clock_out_location}
                onChange={handleClockOutLocation}
              ></Form.Control>
            ) : (
              <Form.Control
                placeholder="Enter Address"
                onChange={handleClockOutLocation}
              />
            )}
          </Form.Group>

          <Form.Group controlId="formPlaintextEmail" column sm="50">
            <Form.Label column sm="50">
              iStaff Approve:
            </Form.Label>
            {"   "}
            <>
              <CDropdown>
                <CDropdownToggle caret color="primary">
                  {formData.approval_status}
                </CDropdownToggle>
                <CDropdownMenu>
                  <CDropdownItem
                    onClick={() => {
                      handleiStaffApprove();
                    }}
                  >
                    Approved
                  </CDropdownItem>
                  <CDropdownItem
                    onClick={() => {
                      handleiStaffDecline();
                    }}
                  >
                    Decline
                  </CDropdownItem>
                </CDropdownMenu>
              </CDropdown>
            </>
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        {!state.loading ? (
          <>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
            <Button
              variant="primary"
              onClick={() => {
                handleSubmit(currentRow, userToken);
              }}
            >
              Submit
            </Button>
          </>
        ) : (
          <SmallLoadingSpinner />
        )}
      </Modal.Footer>
    </Modal>
  );
};

function mapStateToProps(state) {
  return {
    userToken: state.userTokenReducer.userToken,
    pendingPlacements: state.userPlacementsReducer.pendingPlacements,
  };
}

function mapDispatchToState(dispatch, ownProps) {
  return {
    createPlacement: (formData, client) => {
      dispatch({
        type: "CREATE_PLACEMENT",
        newPlacement: { ...formData, client },
      });
    },
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToState
)(AmendTimesheetModal);
